/**
 * Extracts filename from content-disposition header
 * @param {string} contentDisposition - The content-disposition header value
 * @param {string} fallbackFilename - Fallback filename if extraction fails
 * @returns {string} The extracted filename
 */
export const extractFilenameFromHeader = (contentDisposition, fallbackFilename = 'download') => {
  if (!contentDisposition) {
    return fallbackFilename;
  }

  const filenameMatch = contentDisposition.match(/filename=(.+)/);
  if (!filenameMatch || !filenameMatch[1]) {
    return fallbackFilename;
  }

  // Remove quotes if present and decode URI if needed
  let filename = filenameMatch[1].replace(/"/g, '').replace(/'/g, '');

  try {
    filename = decodeURIComponent(filename);
  } catch (e) {
    console.warn('Failed to decode filename:', e);
  }

  return filename;
};

/**
 * Downloads a blob with the specified filename
 * @param {Blob} blob - The blob to download
 * @param {string} filename - The filename for the download
 */
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

/**
 * Downloads a file from an API response with automatic filename extraction
 * @param {Object} response - The API response object
 * @param {Blob} response.data - The file data as blob
 * @param {Object} response.headers - The response headers
 * @param {string} fallbackFilename - Fallback filename if header extraction fails
 * @param {string} contentType - The content type for the blob (defaults to 'application/pdf')
 */
export const downloadFileFromResponse = (response, fallbackFilename = 'download', contentType = 'application/pdf') => {
  const contentDisposition = response.headers['content-disposition'];
  const filename = extractFilenameFromHeader(contentDisposition, fallbackFilename);

  const blob = new Blob([response.data], { type: contentType });

  downloadBlob(blob, filename);
};
